import React, { useEffect, useState } from 'react'
import { FaCalendarAlt, FaHome, FaPlus, FaStream, FaUser } from 'react-icons/fa'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import CalendarDialog from './CalendarDialog'
import GoogleSignInButton from './GoogleSignInButton'

const MobileActionMenu = ({
  onShowFavorites,
  currentShowFavorites,
  onShowRecipeForm,
  showRecipeForm,
  onAddToIngredients,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()
  const [showCalendarDialog, setShowCalendarDialog] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const isHome = location.pathname === '/'
  const isProfile = location.pathname === '/profile'
  const isActivity = location.pathname === '/activity'

  const handleBrowse = () => {
    navigate('/')
    // If we're already on the home page, reset any filters
    if (isHome) {
      onShowFavorites(false)
    }
  }

  const handleActivity = () => {
    navigate('/activity')
  }

  const handleCalendar = () => {
    setShowCalendarDialog(true)
  }

  const handleAddRecipe = () => {
    navigate('/')
    // if currently it is not shown, then scroll to the top before showing it
    if (!showRecipeForm) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    onShowRecipeForm(!showRecipeForm) // Toggle the form instead of just opening it
  }

  const handleProfile = () => {
    navigate('/profile')
  }

  if (!isMobile) return null

  return (
    <>
      <div className="mobile-action-menu fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200">
        <div className="flex justify-around items-center h-16">
          {user ? (
            <>
              <button
                onClick={handleBrowse}
                className="flex flex-col items-center justify-center h-full focus:outline-none group mx-0"
              >
                <FaHome
                  className={`text-xl ${isHome ? 'text-green-600' : 'text-gray-600'}`}
                />
                <span
                  className={`text-xs mt-1 ${isHome ? 'text-green-600' : 'text-gray-600'}`}
                >
                  Browse
                </span>
              </button>
              <button
                onClick={handleActivity}
                className="flex flex-col items-center justify-center h-full focus:outline-none group mx-0"
              >
                <FaStream
                  className={`text-xl ${isActivity ? 'text-green-600' : 'text-gray-600'}`}
                />
                <span
                  className={`text-xs mt-1 ${isActivity ? 'text-green-600' : 'text-gray-600'}`}
                >
                  Activity
                </span>
              </button>
              <button
                onClick={handleAddRecipe}
                className="flex flex-col items-center justify-center h-full focus:outline-none group mx-0 relative"
              >
                <div className="absolute -top-5 bg-green-500 rounded-full p-3 shadow-lg border-2 border-white">
                  <FaPlus className="text-xl text-white" />
                </div>
                <span
                  className={`text-xs mt-6 ${showRecipeForm ? 'text-green-600' : 'text-gray-600'} font-medium`}
                >
                  Add
                </span>
              </button>
              <button
                onClick={handleCalendar}
                className="flex flex-col items-center justify-center h-full focus:outline-none group mx-0"
              >
                <FaCalendarAlt className="text-xl text-gray-600" />
                <span className="text-xs mt-1 text-gray-600">Calendar</span>
              </button>
              <button
                onClick={handleProfile}
                className="flex flex-col items-center justify-center h-full focus:outline-none group mx-0"
              >
                <FaUser
                  className={`text-xl ${isProfile ? 'text-green-600' : 'text-gray-600'}`}
                />
                <span
                  className={`text-xs mt-1 ${isProfile ? 'text-green-600' : 'text-gray-600'}`}
                >
                  Profile
                </span>
              </button>
            </>
          ) : (
            <>
              <div className="w-full flex items-center justify-center">
                <GoogleSignInButton />
              </div>
            </>
          )}
        </div>
      </div>

      <CalendarDialog
        isOpen={showCalendarDialog}
        onClose={() => setShowCalendarDialog(false)}
        selectedRecipe={null}
        onAddToIngredients={(recipeIds) => {
          // Call the parent component's onAddToIngredients with the recipe IDs
          if (onAddToIngredients) {
            onAddToIngredients(recipeIds)
            // Close the dialog after adding to ingredients
            setShowCalendarDialog(false)
          }
        }}
      />
    </>
  )
}

export default MobileActionMenu
